// extracted by mini-css-extract-plugin
module.exports = {"giftCard__fieldsets":"styles_giftCard__fieldsets__VWTPe","giftCard__label":"styles_giftCard__label__HYB6s"};